/* UNDENIABLE — product image zoom (PDP2 gallery). Click/tap any gallery image to open a
   full-screen viewer. Inside the viewer: swipe / arrows / keys to change image; click or tap
   to zoom in at that point (desktop: move the mouse to pan; mobile: drag to pan, pinch to
   zoom 1–5x); Esc or × to close. Self-contained: injects its own CSS, binds via delegation so
   it survives section reloads in the theme editor. Hi-res source = gallery src at width=3000. */
(function () {
  'use strict';
  if (window.__udnZoom) return;
  window.__udnZoom = true;

  var SEL = '.pdp2 .pdp__m img';
  var TAP_ZOOM = 2.5, MAX_ZOOM = 5;

  var css = '' +
    SEL + '{cursor:zoom-in}' +
    '.udz{position:fixed;inset:0;z-index:2147483000;background:#fff;display:none;touch-action:none;-webkit-user-select:none;user-select:none}' +
    '.udz.open{display:block}' +
    '.udz__t{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;touch-action:pan-x}' +
    '.udz__t::-webkit-scrollbar{display:none}' +
    '.udz.zoomed .udz__t{overflow:hidden;touch-action:none}' +
    '.udz__s{flex:0 0 100%;width:100%;height:100%;position:relative;overflow:hidden;scroll-snap-align:start;scroll-snap-stop:always}' +
    '.udz__s img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;transform-origin:0 0;cursor:zoom-in;will-change:transform;-webkit-user-drag:none;user-select:none}' +
    '.udz__s.z img{cursor:zoom-out}' +
    '.udz__s.anim img{transition:transform .28s cubic-bezier(.2,.7,.2,1)}' +
    '.udz__b{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border:1px solid rgba(10,10,11,.15);background:rgba(255,255,255,.9);color:#0a0a0b;cursor:pointer;padding:0;border-radius:0}' +
    '.udz__b svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:1.6}' +
    '.udz__x{top:14px;right:14px}' +
    '.udz__p{left:14px;top:50%;transform:translateY(-50%)}' +
    '.udz__n{right:14px;top:50%;transform:translateY(-50%)}' +
    '.udz__c{position:absolute;z-index:2;left:50%;bottom:16px;transform:translateX(-50%);font:500 12px/1 inherit;letter-spacing:.08em;padding:8px 12px;background:rgba(10,10,11,.6);color:#fff}' +
    '.udz__h{position:absolute;z-index:2;left:50%;top:22px;transform:translateX(-50%);font:500 11px/1 inherit;letter-spacing:.1em;text-transform:uppercase;color:rgba(10,10,11,.55);pointer-events:none;transition:opacity .3s}' +
    '.udz.zoomed .udz__h{opacity:0}' +
    '@media (max-width:900px),(hover:none){.udz__p,.udz__n{display:none}}';

  var ICON = {
    x: '<svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    p: '<svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg>',
    n: '<svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg>'
  };

  var box, track, counter, hint, slides = [], idx = 0, lastFocus = null, bodyOverflow = '';
  var coarse = window.matchMedia && window.matchMedia('(hover:none)').matches;

  function hiRes(src) {
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=3000')
      : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=3000';
  }

  function build() {
    if (box) return;
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    box = document.createElement('div');
    box.className = 'udz';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image zoom');
    box.innerHTML = '<div class="udz__t"></div>' +
      '<button type="button" class="udz__b udz__x" aria-label="Close">' + ICON.x + '</button>' +
      '<button type="button" class="udz__b udz__p" aria-label="Previous image">' + ICON.p + '</button>' +
      '<button type="button" class="udz__b udz__n" aria-label="Next image">' + ICON.n + '</button>' +
      '<div class="udz__h"></div><div class="udz__c"></div>';
    document.body.appendChild(box);
    track = box.querySelector('.udz__t');
    counter = box.querySelector('.udz__c');
    hint = box.querySelector('.udz__h');
    box.querySelector('.udz__x').addEventListener('click', close);
    box.querySelector('.udz__p').addEventListener('click', function () { go(idx - 1); });
    box.querySelector('.udz__n').addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', function () {
      if (!box.classList.contains('open')) return;
      slides.forEach(function (s) { reset(s, false); });
      track.scrollLeft = idx * track.clientWidth;
    });
  }

  /* ── per-slide transform state ── */
  function apply(s, anim) {
    s.el.classList.toggle('anim', !!anim);
    s.img.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px) scale(' + s.s + ')';
    var z = s.s > 1.01;
    s.el.classList.toggle('z', z);
    if (s === slides[idx]) box.classList.toggle('zoomed', z);
  }
  function clamp(s) {
    var W = s.el.clientWidth, H = s.el.clientHeight;
    s.s = Math.max(1, Math.min(MAX_ZOOM, s.s));
    s.x = Math.min(0, Math.max(W - W * s.s, s.x));
    s.y = Math.min(0, Math.max(H - H * s.s, s.y));
  }
  function zoomAt(s, ns, cx, cy, anim) {
    var r = ns / s.s;
    s.x = cx - (cx - s.x) * r;
    s.y = cy - (cy - s.y) * r;
    s.s = ns;
    clamp(s);
    apply(s, anim);
  }
  function reset(s, anim) { s.s = 1; s.x = 0; s.y = 0; apply(s, anim); }
  function local(s, clientX, clientY) {
    var r = s.el.getBoundingClientRect();
    return { x: clientX - r.left, y: clientY - r.top };
  }

  function bindSlide(s) {
    var el = s.el;

    /* desktop: click toggles zoom at point, mouse movement pans */
    el.addEventListener('click', function (e) {
      if (Date.now() - s.lastTouch < 700) return; // synthetic click after touch
      var p = local(s, e.clientX, e.clientY);
      if (s.s > 1.01) reset(s, true); else zoomAt(s, TAP_ZOOM, p.x, p.y, true);
    });
    el.addEventListener('mousemove', function (e) {
      if (s.s <= 1.01 || coarse) return;
      var p = local(s, e.clientX, e.clientY);
      var W = el.clientWidth, H = el.clientHeight;
      s.x = -(p.x / W) * (W * s.s - W);
      s.y = -(p.y / H) * (H * s.s - H);
      apply(s, false);
    });

    /* touch: tap/double-tap to toggle, pinch to zoom, drag to pan when zoomed */
    var t = null;
    el.addEventListener('touchstart', function (e) {
      s.lastTouch = Date.now();
      if (e.touches.length === 2) {
        var a = e.touches[0], b = e.touches[1];
        var m = local(s, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
        t = { pinch: true, d0: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), s0: s.s, x0: s.x, y0: s.y, mx: m.x, my: m.y, moved: true };
        box.classList.add('zoomed');
      } else if (e.touches.length === 1) {
        var p = local(s, e.touches[0].clientX, e.touches[0].clientY);
        t = { pinch: false, sx: p.x, sy: p.y, x0: s.x, y0: s.y, t0: Date.now(), moved: false };
      }
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!t) return;
      if (t.pinch && e.touches.length === 2) {
        e.preventDefault();
        var a = e.touches[0], b = e.touches[1];
        var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        var m = local(s, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
        var ns = Math.max(1, Math.min(MAX_ZOOM, t.s0 * d / t.d0));
        var r = ns / t.s0;
        s.s = ns;
        s.x = m.x - (t.mx - t.x0) * r;
        s.y = m.y - (t.my - t.y0) * r;
        clamp(s);
        apply(s, false);
      } else if (!t.pinch && e.touches.length === 1) {
        var p = local(s, e.touches[0].clientX, e.touches[0].clientY);
        if (Math.abs(p.x - t.sx) > 8 || Math.abs(p.y - t.sy) > 8) t.moved = true;
        if (s.s > 1.01) {
          e.preventDefault();
          s.x = t.x0 + (p.x - t.sx);
          s.y = t.y0 + (p.y - t.sy);
          clamp(s);
          apply(s, false);
        }
      }
    }, { passive: false });
    el.addEventListener('touchend', function (e) {
      s.lastTouch = Date.now();
      if (!t) return;
      if (t.pinch) {
        if (e.touches.length === 0) { if (s.s < 1.05) reset(s, true); else apply(s, false); t = null; }
        return;
      }
      if (!t.moved && Date.now() - t.t0 < 350) {
        if (s.s > 1.01) reset(s, true); else zoomAt(s, TAP_ZOOM, t.sx, t.sy, true);
      }
      t = null;
    });
  }

  /* ── lazy hi-res loading (current ±1) ── */
  function load(i) {
    var s = slides[i];
    if (s && !s.img.getAttribute('src')) s.img.setAttribute('src', s.src);
  }
  function setIdx(i) {
    if (i !== idx && slides[idx]) reset(slides[idx], false);
    idx = i;
    load(i); load(i + 1); load(i - 1);
    counter.textContent = (i + 1) + ' / ' + slides.length;
    counter.style.display = slides.length > 1 ? '' : 'none';
    box.classList.toggle('zoomed', slides[i].s > 1.01);
  }
  function onScroll() {
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    if (i !== idx && i >= 0 && i < slides.length) setIdx(i);
  }
  function go(i) {
    if (i < 0 || i >= slides.length) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    setIdx(i);
  }
  function onKey(e) {
    if (!box || !box.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(idx - 1);
    else if (e.key === 'ArrowRight') go(idx + 1);
  }

  function open(imgs, start) {
    build();
    track.innerHTML = '';
    slides = imgs.map(function (im) {
      var el = document.createElement('div');
      el.className = 'udz__s';
      var img = document.createElement('img');
      img.alt = im.getAttribute('alt') || '';
      img.draggable = false;
      el.appendChild(img);
      track.appendChild(el);
      var s = { el: el, img: img, src: hiRes(im.currentSrc || im.getAttribute('src')), s: 1, x: 0, y: 0, lastTouch: 0 };
      bindSlide(s);
      return s;
    });
    box.querySelector('.udz__p').style.visibility = slides.length > 1 ? '' : 'hidden';
    box.querySelector('.udz__n').style.visibility = slides.length > 1 ? '' : 'hidden';
    hint.textContent = coarse ? 'Tap or pinch to zoom' : 'Click to zoom';
    lastFocus = document.activeElement;
    bodyOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    box.classList.add('open');
    idx = -1;
    track.scrollLeft = start * track.clientWidth;
    setIdx(start);
    box.querySelector('.udz__x').focus({ preventScroll: true });
  }
  function close() {
    if (!box) return;
    box.classList.remove('open', 'zoomed');
    document.documentElement.style.overflow = bodyOverflow;
    track.innerHTML = '';
    slides = [];
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var img = e.target && e.target.closest && e.target.closest(SEL);
    if (!img) return;
    var gallery = img.closest('.pdp__m');
    var imgs = [].slice.call(gallery.querySelectorAll('img')).filter(function (im) {
      return im.offsetParent !== null || getComputedStyle(im).display !== 'none';
    });
    var start = Math.max(0, imgs.indexOf(img));
    e.preventDefault();
    open(imgs, start);
  });

  /* zoom-in cursor on gallery images before first open */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
